import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { TranslocoService, TranslocoModule } from '@ngneat/transloco';
import { Utils } from '../../../shared/utils';
import { ContactInfo } from '../../../models';
import { ContactService, NotificationService } from '../../../services';
import { EmailCheckValidator } from '../../../validators';
import { TextFormFieldComponent } from '../../../shared/components/inputs/text-form-field/text-form-field.component';
import { MatButton } from '@angular/material/button';
import { NgClass } from '@angular/common';
import { MatError } from '@angular/material/form-field';

@Component({
  selector: 'app-newsletter-form',
  templateUrl: './newsletter-form.component.html',
  styleUrls: ['./newsletter-form.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TextFormFieldComponent,
    MatButton,
    NgClass,
    MatError,
    TranslocoModule,
  ],
})
export class NewsletterFormComponent implements OnInit, OnDestroy {
  emailCheckValidator = inject(EmailCheckValidator);
  private contactService = inject(ContactService);
  private translocoService = inject(TranslocoService);
  private notificationService = inject(NotificationService);

  @Input() style: '--custom-event' | '--primary' = '--custom-event';
  public errors = [];
  public newsletterForm = new UntypedFormGroup({});
  public newsletter: Partial<{fullName, email}> = {};
  public isSendingMessage = false;
  public sendingDate: Date;
  public nameRegex = Utils.nameRegex;
  public translations: any;
  private translationSub: Subscription;

  ngOnInit(): void {
    this.translationSub = this.translocoService.selectTranslateObject('homeOrga')
      .subscribe((translations) => {
        this.translations = translations;
      });
  }

  registerNewsletter() {
    this.sendingDate = null;
    if (!this.newsletterForm.valid) {
      this.errors = ['invalidForm'];
      this.isSendingMessage = false;
      return;
    }
    this.isSendingMessage = true;
    const contactPayload: ContactInfo = {
      fullName: this.newsletter.fullName,
      mailAddress: this.newsletter.email,
      subject: 'Nouvelle inscription pour la Newsletter',
      message: `Bonjour,\r\n
                Je viens d'effectuer une demande d'ajout à votre Newsletter.\r\n
                ${this.newsletter.fullName} : ${this.newsletter.email}`,
    };
    this.contactService.sendMessage(contactPayload).subscribe({
      next: () => {
        this.isSendingMessage = false;
        this.sendingDate = new Date();
        this.notificationService.open(this.translations.newsletterSubscription);
        this.newsletterForm.reset();
        this.newsletterForm.markAsPristine();
      },
      error: (err) => {
        // eslint-disable-next-line no-console
        console.log('Error on onSubmitClick function on contact component : ', err);
        this.errors.push('registrationRequestFailed');
        this.errors.push('checkInformationsProvided');
        this.isSendingMessage = false;
      },
    });
  }

  ngOnDestroy(): void {
    this.translationSub?.unsubscribe();
  }

}
